import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import { Container, Alert, Spinner } from 'react-bootstrap';

const NewsletterVerification = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyNewsletter = async () => {
      try {
        const token = searchParams.get('token');
        if (!token) {
          setStatus('error');
          setMessage('Token não encontrado');
          return;
        }

        const response = await axiosInstance.get(`/newsletter/verify?token=${encodeURIComponent(token)}`);
        setStatus('success');
        setMessage(response.message);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Erro ao verificar a newsletter');
      }
    };

    verifyNewsletter();
  }, [searchParams]);

  return (
    <Container className="mt-5">
      {status === 'loading' && (
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">A carregar...</span>
          </Spinner>
          <p className="mt-2">A confirmar a tua inscrição...</p>
        </div>
      )}

      {status === 'success' && (
        <Alert variant="success" className="text-center">
          <h4>Sucesso!</h4>
          <p>{message}</p>
        </Alert>
      )}

      {status === 'error' && (
        <Alert variant="danger" className="text-center">
          <h4>Erro</h4>
          <p>{message}</p>
        </Alert>
      )}
    </Container>
  );
};

export default NewsletterVerification;
